import React from "react";

// Payment method badges — brand logo images provided by the user,
// text-styled fallbacks for methods without an uploaded asset.
const LOGO_IMAGES = {
  visa: { src: "/logos/logo_visa.png", alt: "Visa" },
  mc: { src: "/logos/logo_mastercard.png", alt: "Mastercard" },
  yappy: { src: "/logos/logo_yappy.png", alt: "Yappy" },
  ach: { src: "/logos/logo_ach.png", alt: "ACH Xpress", boost: true },
};

const TEXT_STYLES = {};

const PaymentBadge = ({ style, size = "md" }) => {
  const sizes = {
    sm: { pad: "px-2.5 py-1.5", img: "h-[14px]", imgBoost: "h-[18px]", text: "text-[11px]" },
    md: { pad: "px-3.5 py-2.5", img: "h-[18px]", imgBoost: "h-[24px]", text: "text-[13px]" },
  };
  const s = sizes[size];

  const logo = LOGO_IMAGES[style];
  if (logo) {
    return (
      <span
        className={`inline-flex items-center bg-white border border-black/10 rounded-md shadow-sm ${s.pad} hover:border-black/25 hover:shadow transition-all duration-200`}
      >
        <img src={logo.src} alt={logo.alt} className={`${logo.boost ? s.imgBoost : s.img} w-auto object-contain`} draggable="false" />
      </span>
    );
  }

  const conf = TEXT_STYLES[style];
  if (!conf) return null;
  return (
    <span
      className={`inline-flex items-center bg-white border border-black/10 rounded-md shadow-sm ${s.pad} ${s.text} hover:border-black/25 hover:shadow transition-all duration-200`}
    >
      <span className={conf.className}>{conf.text}</span>
    </span>
  );
};

export default PaymentBadge;
